module.exports = __webpack_public_path__ + "img/avatar-s-13.1875411a.png";